import { Component } from '@angular/core';
import { HeaderComponent } from "../../../../layout/header/header.component";
import { NavbarComponent } from "../../../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../../../layout/sidebar/sidebar.component";
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { EnrollmentService } from '../../../../services/enrollment.services';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { SharedService } from '../../../../services/shared.service';
import { EnrollmentTraductionDto } from '../../../../models/enrollment/enrollmentTraductionDto';
import { EnrollmentCancellationDto, EnrollmentCancellationRequest, EnrollmentCancellationResponse } from '../../../../models/enrollment/enrollmentCancellationDto';
@Component({
  selector: 'app-cancellation-enrollment',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, ReactiveFormsModule, TranslatePipe, PaginatorComponent, AlertComponentComponent],
  templateUrl: './cancellation-enrollment.component.html',
  styleUrl: './cancellation-enrollment.component.css'
})
export class CancellationEnrollmentComponent {
  links: any[] = []; // Lista de links para el sidebar
  cancellationReponse: EnrollmentCancellationResponse = new EnrollmentCancellationResponse();
  cancellationRequest: EnrollmentCancellationRequest = new EnrollmentCancellationRequest();
  cancellationSelected: EnrollmentCancellationDto = new EnrollmentCancellationDto();
  cancellationReponseTraductions: EnrollmentTraductionDto[] = [];
  selectedRowId: number | null = null;
  cancellationForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility()
  constructor(private routelinks: RoutelinksService, private translateService: TranslateService, private enrollmentService: EnrollmentService, private formBuilder: FormBuilder,
     private sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksEnrollment; // Inicializa la propiedad en ngOnInit
    this.initFormReactiveEnrollment();
    this.getAllEnrollment();
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.cancellationRequest.pageRequest.page = page;
      this.getAllEnrollment();
    });
  }

  private initFormReactiveEnrollment(): void {
    this.cancellationForm = this.formBuilder.group({
      idEnrollmentCancellationPattern: [0],
      codeCancellation: [''],
      shortDescription: ['', [Validators.required]],
      typology: [''],
      academicFee: [''],
      resourceRate: [''],
      surcharge: [''],
      administrativeFee: [''],
      active: new FormControl(true),
      additionalCancellationFee: new FormControl(false),
      descriptionCas: ['', [Validators.required]],
      descriptionCat: ['', [Validators.required]],
      descriptionEng: ['', [Validators.required]],
    });
  }

  getAllEnrollment() {
    this.enrollmentService.getListEnrollmentCancellation(this.cancellationRequest.pageRequest).subscribe({
      next: response => {
        console.log(response)
        if (response != null) {
          this.cancellationReponseTraductions = response.listPatternCancellation.enrollmentCancellationPatternTraductionDto
          this.cancellationReponse.enrollmentCancellationDto = response.listPatternCancellation
          this.cancellationReponse.pageDto = response.pageDto !== undefined ? response.pageDto : null;
        }
      }
    });
  }

  checkRow(cancellation?: EnrollmentCancellationDto) {

    if (cancellation) {
      if (this.selectedRowId === cancellation.idEnrollmentCancellationPattern) {
        this.selectedRowId = null;
        return;
      }
      console.log(cancellation)
      this.cancellationSelected = cancellation
      this.selectedRowId = cancellation.idEnrollmentCancellationPattern || null

      this.cancellationForm.patchValue({
        codeCancellation: cancellation?.codeCancellation,
        shortDescription: cancellation?.shortDescription,
        typology: cancellation?.typology,
        surcharge: cancellation?.surcharge,
        administrativeFee: cancellation?.administrativeFee,
        academicFee: cancellation?.academicFee,
        resourceRate: cancellation?.resourceRate,
        active: cancellation?.active,
        additionalCancellationFee: cancellation.additionalCancellationFee == 'S',
        learningResourcesFee: cancellation.additionalCancellationFee == 'S'
      });

      cancellation.enrollmentCancellationPatternTraductionDto?.forEach(modifyTraduction => {
        modifyTraduction.languageDto?.idLanguage == 1 ? this.cancellationForm.get('descriptionCas')?.patchValue(modifyTraduction.longDescription) : null;
        modifyTraduction.languageDto?.idLanguage == 2 ? this.cancellationForm.get('descriptionCat')?.patchValue(modifyTraduction.longDescription) : null;
        modifyTraduction.languageDto?.idLanguage == 3 ? this.cancellationForm.get('descriptionEng')?.patchValue(modifyTraduction.longDescription) : null;
      });
      console.log(this.cancellationForm.value)

    } else {
      // Modo creación
      this.selectedRowId = null;
      this.isCreate = true;
      this.cancellationForm.enable();
      this.cancellationForm.reset();
    }
  }

  createOrUpdateCancellation(): void {
    this.buildCancellationDto()
    if (!this.selectedRowId) {
      this.enrollmentService.insertEnrollmentCancellation(this.cancellationRequest.enrollmentCancellationDto).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha creat correctament"
          this.resetValues();
        }, error: (error: { error: { message: string; }; }) => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
        }
      })
    }
    //modo edicion
    else {
      this.enrollmentService.updateEnrollmentCancellation(this.cancellationRequest.enrollmentCancellationDto).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha editat correctament"
          this.resetValues();
        }, error: (error) => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
        }
      })
    }
    this.getAllEnrollment();
  }

  buildCancellationDto() {
    this.cancellationRequest.enrollmentCancellationDto = new EnrollmentCancellationDto(); // Inicializa de 0 el objeto
    if (this.selectedRowId) {
      this.cancellationRequest.enrollmentCancellationDto.idEnrollmentCancellationPattern = this.selectedRowId
    }
    this.cancellationRequest.enrollmentCancellationDto.shortDescription = this.cancellationForm.get('shortDescription')?.value
    this.cancellationRequest.enrollmentCancellationDto.active = this.cancellationForm.get('active')?.value
    this.cancellationRequest.enrollmentCancellationDto.academicFee = this.cancellationForm.get('academicFee')?.value
    this.cancellationRequest.enrollmentCancellationDto.surcharge = this.cancellationForm.get('surcharge')?.value
    this.cancellationRequest.enrollmentCancellationDto.typology = this.cancellationForm.get('typology')?.value
    this.cancellationRequest.enrollmentCancellationDto.resourceRate = this.cancellationForm.get('resourceRate')?.value
    this.cancellationForm.get('additionalCancellationFee')?.value ? this.cancellationRequest.enrollmentCancellationDto.additionalCancellationFee = "S" : this.cancellationRequest.enrollmentCancellationDto.additionalCancellationFee = "N";
    this.cancellationRequest.enrollmentCancellationDto.administrativeFee = this.cancellationForm.get('administrativeFee')?.value
    this.cancellationRequest.enrollmentCancellationDto.codeCancellation = this.cancellationForm.get('codeCancellation')?.value

    this.cancellationRequest.enrollmentCancellationDto.enrollmentCancellationPatternTraductionDto = [
      { languageDto: { idLanguage: 1 }, longDescription: undefined, idEnrollmentCancellationPatternTraduction: undefined },
      { languageDto: { idLanguage: 2 }, longDescription: undefined, idEnrollmentCancellationPatternTraduction: undefined },
      { languageDto: { idLanguage: 3 }, longDescription: undefined, idEnrollmentCancellationPatternTraduction: undefined }
    ];

    this.cancellationRequest.enrollmentCancellationDto.enrollmentCancellationPatternTraductionDto.forEach((translation) => {
      if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
        translation.longDescription = this.cancellationForm.get('descriptionCas')?.value ?? undefined;
        translation.idEnrollmentCancellationPatternTraduction = this.cancellationSelected?.enrollmentCancellationPatternTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 1 })[0].idEnrollmentCancellationPatternTraduction || undefined
      } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
        translation.longDescription = this.cancellationForm.get('descriptionCat')?.value ?? undefined;
        translation.idEnrollmentCancellationPatternTraduction = this.cancellationSelected?.enrollmentCancellationPatternTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 2 })[0].idEnrollmentCancellationPatternTraduction || undefined

      } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
        translation.longDescription = this.cancellationForm.get('descriptionEng')?.value ?? undefined;
        translation.idEnrollmentCancellationPatternTraduction = this.cancellationSelected?.enrollmentCancellationPatternTraductionDto?.filter(modify => { return modify.languageDto?.idLanguage == 3 })[0].idEnrollmentCancellationPatternTraduction || undefined
      }
    });
  }


  private resetValues(): void {
    this.getAllEnrollment();
    this.cancellationForm.reset();
    this.selectedRowId = null;
  }

}


